import { Modal, Button } from "react-bootstrap";
type TParams = {
  show: boolean;
  onClose: any;
  onSuccess: any;
  message: string[];
}
const ModalAlert = (props: TParams) => {
  const { show, onClose, onSuccess, message } = props

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Newton clothes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message.map((text, index) => < ><span key={index}>{text}</span>< br /></>)}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          onClick={onSuccess}
        >
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAlert;
